import React, { useState } from 'react';
import { Paper, Card, CardContent, Typography, TextField, Button, Grid, Box, Snackbar,Alert } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLocation } from 'react-router-dom';
import { vendorApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';

const UpdatePropertyPrice = () => {
  
  const [newPrice, setNewPrice] = useState('');
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const location=useLocation();
  const navigate = useNavigate();
  const {propertyData}=location.state || {};
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity
  const validate = () => {
  if (newPrice === '' || Number(newPrice) <= 0) {
    setError(true);
    setErrorText("Please enter a valid price greater than 0.");
    return false;
  } else {
    setError(false);
    setErrorText('');
    return true;
  }
};

  const handleSnackbarClose = () => setSnackbarOpen(false);
  const handleUpdate = async () => {
    if(!validate()) return;
    try{
      await vendorApi.updatePropertyPrice({
  PropertyId: propertyData[0]?.Id,
  PropertyType: propertyData[0]?.PropertyType,
  PropertyPrice: Number(newPrice)
});

      setSnackbarMessage("Price Updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true); // Show success snackbar


    }
    catch(error){
         console.error(error);
          setSnackbarMessage("Failed to update price. Please try again.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true); 
    }
    
  };

  const handleCancel = () => {
    setNewPrice('');
    navigate(-1);
  };

  return (
    <Paper elevation={3} sx={{ padding: 4  }}>

      <Grid container spacing={4}>

        {/* Card 1 - Display Property Info */}
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {propertyData[0].PropertyName}
              </Typography>
              <Box display="flex" alignItems="center" mb={1}>
                <LocationOnIcon sx={{ color: 'gray', marginRight: 1 }} />
                <Typography variant="body1">{propertyData[0].City}</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Current Market Price: <strong>{propertyData[0].MarketPrice}</strong>
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card 2 - Update Price */}
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Update Property Price
              </Typography>
             
               <TextField
  label="New Price"
  variant="outlined"
  type="number"
  value={newPrice}
  onChange={(e) => {
    const value = e.target.value;
    setNewPrice(value);

    // Only clear error if value is valid
    if (value !== '' && Number(value) > 0) {
      setError(false);
      setErrorText('');
    }
  }}
  fullWidth
  error={error}
  helperText={errorText}
/>

                <Box sx={{display:'flex',justifyContent:'flex-end',gap:3,marginTop:3}}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleUpdate}>
                  Update Price
                </Button>
                </Box>
            
            </CardContent>
          </Card>
        </Grid>

      </Grid>
       <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity={snackbarSeverity}
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
     
    </Paper>
  );
};

export default UpdatePropertyPrice;
